import React, { useState } from "react";
import {
  Table,
  Button,
  Row,
  Col,
  Input,
  Tooltip,
  Modal,
  Divider,
  Typography,
  Popconfirm,
  Pagination,
  Select,
  DatePicker,
} from "antd";
import {
  EyeOutlined,
  DeleteOutlined,
  SearchOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { useAdminInvoices } from "../../Hooks/Admin/useInvoices";
import ReactDOMServer from "react-dom/server";
import html2pdf from "html2pdf.js";

const { Text } = Typography;

const Index = () => {
  const dispatch = useDispatch();

  const { getAllInvoices, deleteInvoices, getAllUser } = useAdminInvoices();

  const [createInvoiceData, setCreateInvoiceData] = React.useState({
    employeeName: "",
    employeeEmail: "",
    invoiceNumber: "",
    invoiceDate: null,
    salaryMonth: null,
    designation: "",
    company: "",
    usdAmount: 0,
    bonusAmount: 0,
    expenseAmount: 0,
  });
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRow, setSelectedRow] = useState({});

  const [tableData, settableData] = React.useState([]);
  const [searchText, setsearchText] = React.useState("");

  const [selectBulk, setselectBulk] = React.useState({});

  const [selectedUser, setselectedUser] = React.useState("");

  const [startpoint, setstartpoint] = React.useState(0);
  const [currentpage, setcurrentpage] = React.useState(1);
  const [totalData, settotalData] = React.useState(0);

  const [selectedMonth, setselectedMonth] = React.useState("");
  const [selectedYear, setselectedYear] = React.useState("");

  const [selectedUserData, setselectedUserData] = React.useState({
    total_amount: 0,
    USD_amount: 0,
    bonus_amount: 0,
    expense_amount: 0,
  });

  const [tableCount, settableCount] = React.useState(50);

  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const [userList, setuserList] = React.useState([]);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = (data) => {
    generatePDF(data);
    // setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  React.useEffect(() => {
    get_all_invoices();
  }, [selectedUser, selectedMonth, selectedYear]);

  React.useEffect(() => {
    get_all_users();
  }, []);

  const get_all_users = async () => {
    try {
      const data = await getAllUser(dispatch);
      if (data.length > 0) {
        const arr = [];
        data.map((item) => {
          arr.push({ label: item.name, value: item.id });
        });
        setuserList(arr);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const get_all_invoices = async (page, count) => {
    const pagesizes = count ? count : tableCount;
    try {
      const data = await getAllInvoices(
        {
          search: searchText,
          start: parseInt(page * pagesizes - pagesizes),
          length: parseInt(pagesizes),
          user_id: selectedUser,
          month: selectedMonth,
          year: selectedYear,
        },
        dispatch
      );
      if (data) {
        console.log(data);

        settableData(data.data);
        setstartpoint(data.start);
        settotalData(data.total);
        if (selectedUser) {
          setselectedUserData(data.amount);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const delete_invoices = async (id) => {
    try {
      const data = await deleteInvoices(id, dispatch);
      if (data.code === 2001) {
        toast.success(data.message);
        get_all_invoices();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // const generatePDF = () => {
  //   const input = document.getElementById("invoice-content");

  //   html2canvas(input, { scale: 2 }).then((canvas) => {
  //     const imgData = canvas.toDataURL("image/png");
  //     const pdf = new jsPDF();
  //     const imgWidth = 190;
  //     const pageHeight = pdf.internal.pageSize.height;
  //     const imgHeight = (canvas.height * imgWidth) / canvas.width;
  //     const topPadding = 10;
  //     let heightLeft = imgHeight;

  //     let position = topPadding;

  //     pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
  //     heightLeft -= pageHeight - topPadding;

  //     while (heightLeft >= 0) {
  //       position = heightLeft - imgHeight + topPadding;
  //       pdf.addPage();
  //       pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
  //       heightLeft -= pageHeight;
  //     }

  //     pdf.save("invoice.pdf");
  //   });
  // };

  // const generatePDF = (data, htmlCode) => {
  //   const pdf = new jsPDF("p", "pt", "a4");
  //   const element = htmlCode
  //     ? htmlCode
  //     : document.getElementById("invoice-content");
  //   pdf.setFont("helvetica");
  //   pdf.html(element, {
  //     callback: function (doc) {
  //       doc.save(
  //         `${data.employeeName.replace(" ", "-")}-${dayjs()
  //           .subtract(1, "month")
  //           .format("MM")}-${dayjs().format("YYYY")}.pdf`
  //       );
  //     },
  //     x: 20,
  //     y: 10,
  //     width: 555,
  //     windowWidth: 675,
  //   });
  // };

  const generatePDF = (data, htmlCode) => {
    console.log(data);

    const element = htmlCode
      ? htmlCode
      : document.getElementById("invoice-content");
    const opt = {
      margin: 20,
      filename: `${data.employeeName.replace(" ", "-")}-${dayjs(
        data.salaryMonth,
        "MMMM YYYY"
      ).format("MM")}-${dayjs(data.salaryMonth, "MMMM YYYY").format(
        "YYYY"
      )}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "pt", format: "a4", orientation: "p" },
    };

    // Generate and save the PDF
    html2pdf().set(opt).from(element).save();
  };

  const columns = [
    {
      title: "Invoice No.",
      dataIndex: "invoice_no",
      key: "invoice_no",
    },
    {
      title: "Name",
      dataIndex: "user_id",
      key: "user_id",
      align: "center",
      render(text) {
        return <div>{userList.find((item) => item.value === text)?.label}</div>;
      },
    },
    {
      title: "Company",
      key: "company",
      align: "center",
      render: (_, record) => {
        const invoiceData = JSON.parse(record.invoice_data);
        const companyMap = {
          trackship: "TrackShip",
          zorem: "Zorem",
          zorem_us: "Zorem US",
          todo_today: "TODO.TODAY PTE. LTD",
        };
        return <div>{companyMap[invoiceData.company_type] || invoiceData.company_type}</div>;
      },
    },
    {
      title: "Date",
      dataIndex: "invoice_date",
      key: "invoice_date",
    },
    {
      title: "USD($)",
      dataIndex: "USD_amount",
      key: "USD_amount",
    },
    {
      title: "Bonus($)",
      dataIndex: "bonus_amount",
      key: "bonus_amount",
    },
    {
      title: "Expense($)",
      dataIndex: "expense_amount",
      key: "expense_amount",
    },
    {
      title: "Total($)",
      dataIndex: "total",
      key: "total",
      render: (text, record) => (
        <div>
          {parseFloat(record.USD_amount) +
            parseFloat(record.bonus_amount) +
            parseFloat(record.expense_amount)}
        </div>
      ),
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Tooltip title="View">
            <Button
              type="text"
              style={{ color: "#1677ff" }}
              icon={<EyeOutlined />}
              onClick={() => {
                const invoiceData = JSON.parse(record.invoice_data);
                setCreateInvoiceData({
                  employeeName: invoiceData.employee_name,
                  employeeEmail: invoiceData.employee_email,
                  invoiceNumber: invoiceData.invoice_no,
                  invoiceDate: record.invoice_date,
                  salaryMonth: invoiceData.salary_month,
                  designation: invoiceData.designation,
                  company: invoiceData.company_type,
                  usdAmount: invoiceData.USD_amount ?? "0",
                  bonusAmount: invoiceData.bonus_amount ?? "0",
                  expenseAmount: invoiceData.expense_amount ?? "0",
                });
                showModal();
              }}
            ></Button>
          </Tooltip>
          <Tooltip title="Delete">
            <Popconfirm
              title="Delete?"
              description="Are you sure to delete this invoice?"
              icon={
                <QuestionCircleOutlined
                  style={{
                    color: "red",
                  }}
                />
              }
              onConfirm={() => {
                if (record.id) {
                  delete_invoices(record.id);
                } else {
                  toast.error("Something went wrong");
                }
              }}
              placement="bottom"
              onCancel={() => {}}
              okText="Yes"
              cancelText="No"
            >
              <Button type="text" danger icon={<DeleteOutlined />}></Button>
            </Popconfirm>
          </Tooltip>
        </div>
      ),
    },
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedKeys, selectedRows) => {
      setSelectedRow(selectedRows);
      setSelectedRowKeys(selectedKeys);
    },
  };

  const downloadBulkInvoice = () => {
    selectedRow.map((item) => {
      const invoiceData = JSON.parse(item.invoice_data);
      const obj = {
        employeeName: invoiceData.employee_name,
        employeeEmail: invoiceData.employee_email,
        invoiceNumber: invoiceData.invoice_no,
        invoiceDate: item.invoice_date,
        salaryMonth: invoiceData.salary_month,
        designation: invoiceData.designation,
        company: invoiceData.company_type,
        usdAmount: invoiceData.USD_amount ?? "0",
        bonusAmount: invoiceData.bonus_amount ?? "0",
        expenseAmount: invoiceData.expense_amount ?? "0",
      };
      const htmlString = ReactDOMServer.renderToString(invoiceHtml(obj));
      generatePDF(obj, `<div class="ant-card-body">${htmlString}</div>`);
    });
  };

  const invoiceHtml = (invoiceData) => {
    return (
      <div
        id="invoice-content"
        style={{
          fontFamily: "Helvetica, Arial, sans-serif",
          fontSize: "12px",
          color: "#000",
        }}
      >
        <div>
          <Row justify="space-between" style={{ marginBottom: "20px" }}>
            <Col>
              <div style={{ color: "#888", fontSize: "12px" }}>
                <b>FROM</b>
              </div>
              <Text style={{ fontWeight: "bold" }}>
                {invoiceData.employeeName}
              </Text>
              <br />
              <Text> Ahmedabad </Text>
              <br />
              <Text
                style={{
                  wordBreak: "break-all",
                  overflowWrap: "break-word",
                  whiteSpace: "normal",
                  fontFamily: "Helvetica, Arial, sans-serif",
                }}
              >
                {invoiceData.employeeEmail}
              </Text>
            </Col>
            {invoiceData.company === "trackship" ? (
              <Col>
                <div style={{ color: "#888", fontSize: "12px" }}>
                  <b>TO</b>
                </div>
                <Text style={{ fontWeight: "bold" }}> TrackShip, Inc. </Text>
                <br />
                <Text> 600 N Broad Street </Text>
                <br />
                <Text> Suite 5 # 544 </Text>
                <br />
                <Text> Middletown, DE 19709 </Text>
                <br />
                <Text
                  style={{
                    wordBreak: "break-all",
                    overflowWrap: "break-word",
                    whiteSpace: "normal",
                    fontFamily: "Helvetica, Arial, sans-serif",
                  }}
                >
                  {" "}
                  info@trackship.com{" "}
                </Text>
              </Col>
            ) : invoiceData.company === "zorem_us" ? (
              <Col>
                <div style={{ color: "#888", fontSize: "12px" }}>
                  <b>TO</b>
                </div>
                <Text style={{ fontWeight: "bold" }}> Zorem Tech, Inc. </Text>
                <br />
                <Text> 600 N Broad Street </Text>
                <br />
                <Text> Suite 5 # 544 </Text>
                <br />
                <Text> Middletown, DE, 19709 </Text>
                <br />
                <Text
                  style={{
                    wordBreak: "break-all",
                    overflowWrap: "break-word",
                    whiteSpace: "normal",
                    fontFamily: "Helvetica, Arial, sans-serif",
                  }}
                >
                  {" "}
                  info@zorem.com{" "}
                </Text>
              </Col>
            ) : invoiceData.company === "todo_today" ? (
              <Col>
                <div style={{ color: "#888", fontSize: "12px" }}>
                  <b>TO</b>
                </div>
                <Text style={{ fontWeight: "bold" }}> TODO.TODAY PTE. LTD </Text>
                <br />
                <Text> 160 Robinson Road, #14-04 </Text>
                <br />
                <Text> Singapore Business Federation Center </Text>
                <br />
                <Text> Singapore 068914 </Text>
                <br />
                <Text
                  style={{
                    wordBreak: "break-all",
                    overflowWrap: "break-word",
                    whiteSpace: "normal",
                    fontFamily: "Helvetica, Arial, sans-serif",
                  }}
                >
                  {" "}
                  info@todo.today{" "}
                </Text>
              </Col>
            ) : (
              <Col>
                <div style={{ color: "#888", fontSize: "12px" }}>
                  <b>TO</b>
                </div>
                <Text style={{ fontWeight: "bold" }}>
                  {" "}
                  zorem int'l trade LTD.{" "}
                </Text>
                <br />
                <Text> Israel </Text>
                <br />
                <Text
                  style={{
                    wordBreak: "break-all",
                    overflowWrap: "break-word",
                    whiteSpace: "normal",
                    fontFamily: "Helvetica, Arial, sans-serif",
                  }}
                >
                  {" "}
                  info@zorem.com{" "}
                </Text>
              </Col>
            )}
          </Row>

          <Divider />

          <Row justify="space-between" style={{ marginBottom: "20px" }}>
            <Col>
              <Text>
                <b>Invoice No:</b> {invoiceData.invoiceNumber}
              </Text>
              <br />
              <Text>
                <b>Invoice Date:</b>{" "}
                {dayjs(invoiceData.invoiceDate, "YYYY-MM-DD").format(
                  "MMMM Do, YYYY"
                )}
              </Text>
            </Col>
          </Row>

          <Row justify="start">
            <Col span={24}>
              <div style={{ width: "100%", marginBottom: "40px" }}>
                <div
                  style={{
                    borderBottom: "1px solid #dddddd",
                    borderTop: "1px solid #dddddd",
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "10px 0",
                    backgroundColor: "#f5f5f5",
                  }}
                >
                  <div style={{ textAlign: "left", marginLeft: "10px" }}>
                    <b>Item</b>
                  </div>
                  <div style={{ textAlign: "right", marginRight: "10px" }}>
                    <b>Subtotal</b>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "10px",
                    borderBottom: "1px solid #dddddd",
                  }}
                >
                  <div>
                    {dayjs(invoiceData.salaryMonth, "MMMM YYYY").format("MMMM")}{" "}
                    Invoice
                  </div>
                  <div style={{ textAlign: "right" }}>
                    ${invoiceData.usdAmount}
                  </div>
                </div>
                {invoiceData.bonusAmount &&
                parseInt(invoiceData.bonusAmount) > 0 ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px",
                      borderBottom: "1px solid #dddddd",
                    }}
                  >
                    <div>Bonus</div>
                    <div style={{ textAlign: "right" }}>
                      ${invoiceData.bonusAmount}
                    </div>
                  </div>
                ) : null}
                {invoiceData.expenseAmount &&
                parseInt(invoiceData.expenseAmount) > 0 ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px",
                      borderBottom: "1px solid #dddddd",
                    }}
                  >
                    <div>Expense</div>
                    <div style={{ textAlign: "right" }}>
                      ${invoiceData.expenseAmount}
                    </div>
                  </div>
                ) : null}
              </div>
            </Col>
          </Row>
          <Row justify="end">
            <Col span={10}>
              <div style={{ width: "100%", marginBottom: "40px" }}>
                <div
                  style={{
                    borderBottom: "1px solid #dddddd",
                    borderTop: "1px solid #dddddd",
                    display: "flex",
                    justifyContent: "center",
                    padding: "10px 0",
                    backgroundColor: "#f5f5f5",
                  }}
                >
                  <div style={{ marginLeft: "10px" }}>
                    <b>Invoice Summary</b>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "10px",
                    borderBottom: "1px solid #dddddd",
                  }}
                >
                  <div>Total</div>
                  <div style={{ textAlign: "right" }}>
                    $
                    {parseFloat(invoiceData.usdAmount || 0) +
                      parseFloat(invoiceData.bonusAmount || 0) +
                      parseFloat(invoiceData.expenseAmount || 0)}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  };

  return (
    <div>
      <Row style={{ marginBottom: "20px" }} gutter={[16, 24]}>
        <Col span={6}>
          <Input
            size="large"
            placeholder="Search..."
            prefix={<SearchOutlined />}
            onBlur={() => {
              get_all_invoices();
            }}
            onPressEnter={() => {
              get_all_invoices();
            }}
            onChange={(e) => {
              if (e.target.value) {
                setsearchText(e.target.value);
              } else {
                setsearchText("");
                get_all_invoices();
              }
            }}
          />
        </Col>
        <Col span={6}>
          <Select
            size="large"
            style={{ width: "100%" }}
            defaultValue={""}
            placeholder="Select User"
            options={[{ value: "", label: "All Users" }, ...userList]}
            onChange={(e) => {
              setselectedUser(e);
            }}
          />
        </Col>
        <Col span={6}>
          <Select
            size="large"
            style={{ width: "100%" }}
            placeholder="Select Months"
            defaultValue={""}
            onChange={(e) => {
              setselectedMonth(e);
            }}
            options={[
              { value: "", label: "All Months" },
              { value: "1", label: "January" },
              { value: "2", label: "February" },
              { value: "3", label: "March" },
              { value: "4", label: "April" },
              { value: "5", label: "May" },
              { value: "6", label: "June" },
              { value: "7", label: "July" },
              { value: "8", label: "August" },
              { value: "9", label: "September" },
              { value: "10", label: "October" },
              { value: "11", label: "November" },
              { value: "12", label: "December" },
            ]}
          ></Select>
        </Col>
        <Col span={6}>
          <DatePicker
            style={{ width: "100%" }}
            size="large"
            maxDate={dayjs()}
            // defaultValue={dayjs()}
            format={"YYYY"}
            onChange={(date, dateString) => {
              setselectedYear(dateString);
            }}
            picker="year"
          />
        </Col>
      </Row>
      <Row style={{ marginBottom: "20px" }} gutter={[16, 24]}>
        <Col span={6}>
          <Select
            size="large"
            style={{ width: "100%" }}
            placeholder="Bulk Action"
            options={[{ value: "download", label: "Download invoices" }]}
            onChange={(e) => {
              setselectBulk(e);
            }}
          />
        </Col>
        <Col span={6}>
          <Button
            size="large"
            type="primary"
            style={{ width: "50%" }}
            disabled={selectedRow.length === 0}
            onClick={() => {
              if (selectBulk === "download") {
                downloadBulkInvoice();
              } else {
                toast.error("Please select bulk action");
              }
            }}
          >
            Apply
          </Button>
        </Col>
      </Row>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 0 10px 0",
        }}
        className=""
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span>
            Showing
            <strong> {tableData.length > 0 ? startpoint + 1 : 0} </strong> to
            <strong>
              &nbsp;
              {startpoint + (tableCount ? parseInt(tableCount) : 50) > totalData
                ? totalData
                : startpoint + (tableCount ? parseInt(tableCount) : 50)}
              &nbsp;
            </strong>
            of <strong> {totalData}</strong> entries
          </span>
          {selectedUser && (
            <div style={{ borderLeft: "1px solid #d9d9d9", height: "20px" }} />
          )}
          {selectedUser && (
            <div>
              {userList.find((item) => item.value === selectedUser)?.label} got
              total <b>{selectedUserData.total_amount}$</b> as sallary of{" "}
              <b>{selectedUserData.USD_amount}$</b> + bonus of{" "}
              <b>{selectedUserData.bonus_amount}$</b> + expense of{" "}
              <b>{selectedUserData.expense_amount}$</b> .
            </div>
          )}
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Pagination
            current={currentpage}
            onChange={(e) => {
              setcurrentpage(e);
              get_all_invoices(e);
            }}
            pageSize={tableCount ? parseInt(tableCount) : 50}
            total={totalData}
            showSizeChanger={false}
          />
        </div>
      </div>
      <Table
        bordered
        pagination={false}
        columns={columns}
        dataSource={tableData}
        rowSelection={rowSelection}
        // key={"id"}
        rowKey={"id"}
      />
      <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
        <span>
          Showing
          <strong> {tableData.length > 0 ? startpoint + 1 : 0} </strong> to
          <strong>
            &nbsp;
            {startpoint + (tableCount ? parseInt(tableCount) : 50) > totalData
              ? totalData
              : startpoint + (tableCount ? parseInt(tableCount) : 50)}
            &nbsp;
          </strong>
          of <strong> {totalData}</strong> entries
        </span>
      </div>
      <div
        className="paginationSelect"
        style={{ display: "flex", justifyContent: "center", marginTop: 30 }}
      >
        <Pagination
          showQuickJumper
          current={currentpage}
          onChange={(e, pagesize) => {
            setcurrentpage(e);
            settableCount(pagesize);
            get_all_invoices(e, pagesize);
          }}
          defaultPageSize={tableCount ? parseInt(tableCount) : 50}
          total={totalData}
          showSizeChanger
          pageSizeOptions={[50, 100, 200, 500]}
        />
      </div>
      <Modal
        title="View Invoice"
        open={isModalOpen}
        onOk={() => {
          handleOk(createInvoiceData);
        }}
        centered
        okText="Download"
        width={750}
        onCancel={handleCancel}
      >
        {invoiceHtml(createInvoiceData)}
      </Modal>
    </div>
  );
};

export default Index;
